module.exports = __webpack_public_path__ + "img/dynamic_arr_delay.3c40881e.png";